import gql from 'graphql-tag';

const GET_WORKLOGS = gql`
  query getWorklogs($ticketId: ID) {
    getWorklogs(ticketId: $ticketId) {
      worklogId
      technician {
        userId
        name
        firstName
        lastName
      }
      notes
      createdTime
      items {
        itemId
        offering {
          name
          offeringId
          type
        }
        itemName
        billable
        quantity
      }
    }
  }
`;

const GET_WORKLOG = gql`
  query getWorklog($worklogId: ID) {
    getWorklogs(worklogId: $worklogId) {
      worklogId
      technician {
        userId
        name
        firstName
        lastName
      }
      notes
      createdTime
      items {
        itemId
        offering {
          name
          quantity
          price
          offeringId
        }
        itemName
        billable
        quantity
      }
    }
  }
`;

const GET_WORKLOG_TIMERS = gql`
  query getWorklogTimers($ticketId: ID) {
    getWorklogTimers(ticketId: $ticketId) {
      timerId
      offering {
        offeringId
        name
        type
      }
      billable
      technician {
        userId
        name
        firstName
        lastName
      }
      state
      timespent
    }
  }
`;

export { GET_WORKLOG, GET_WORKLOGS, GET_WORKLOG_TIMERS };
